import React, { useState, useEffect } from "react";
import AchievementCard from "./AchievementCard";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import Confetti from "react-confetti";
import { useWindowSize } from "react-use";

const Achievement = () => {
  const [achievementData, setAchievementData] = useState([
    {
      title:
        "1st Place in 2025– Hackathon conducted by Zeal Global Inc, Over AI Based Project.",
      link: "https://drive.google.com/file/d/1w0ndctLk3ZbdfrVi54BoBn7W9jROC8Nb/view?usp=sharing",
    },
    {
      title:
        "1st Place in 2024– Hackathon conducted by Zeal Global Inc, On Web developement Based Project.",
      link: "https://drive.google.com/file/d/1AYce9sRtyZy7xyijHgGwh90ya3iInbuz/view?usp=sharing",
    },
    {
      title: "Top 50– Adobe GenSolve Hackathon by Adobe & GeeksforGeeks.",
      // link: "https://drive.google.com/file/d/16Z6onZQD2pPFIfWJB51qoxBlScSn5Qy9/view?usp=drive_link",
    },
    {
      title: "UBS Hackathon - 3rd Prize out of 400 Teams",
      link: "https://drive.google.com/file/d/1F8JcAofodH6eR2oDJl3YGo66acCq_RJH/view?usp=sharing",
    },
    {
      title:
        "Ranked Top 16 in ATMECS Hackathon for developing an AI-driven medical platform.",
      link: "https://drive.google.com/file/d/1jsZvsWChH0WPZo84pcC0-qXcvLE1mslU/view?usp=sharing",
    },
    {
      title:
        "LeetCode Knight: 700+ problems solved, peak rating 1865, best rank 498.",
      // link: "https://codolio.com/profile/Suryanra",
    },
  ]);

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  const [showConfetti, setShowConfetti] = useState(false);
  const { width, height } = useWindowSize();
  useEffect(() => {
    if (inView) {
      setShowConfetti(true);
      setTimeout(() => setShowConfetti(false), 4000); // Confetti disappears after 4 seconds
    }
  }, [inView]);

  return (
    <motion.div
      className="Achievement"
      id="Achievement"
      ref={ref}
      initial={{ opacity: 0 }}
      animate={inView ? { opacity: 1 } : {}}
      transition={{ duration: 0.8 }}>
      {/* 🎉 Confetti Effect */}

      <motion.div
        className="AchievementHeading"
        initial={{ y: -20, opacity: 0 }}
        animate={inView ? { y: 0, opacity: 1 } : {}}
        transition={{ duration: 0.6, ease: "easeOut" }}>
        🎉 Achievements 🎉
      </motion.div>
      {showConfetti && <Confetti width={width} height={height} />}
      <motion.div className="achievementContent">
        {achievementData.map((data, index) => (
          <AchievementCard
            data={data}
            key={index}
            index={index}
            inView={inView}
          />
        ))}
      </motion.div>
    </motion.div>
  );
};

export default Achievement;
